import moment from 'moment';
import { EXTERNALDATA_STATUS, EXTERNALDATA_TAB } from '../../common/const';
import {
  SET_EXTAB,
  SET_INIT_EXTERNAL_DATA_HISTORY_STATE,
  SET_INIT_EXTERNAL_DATA_SEND_HISTORY_STATE,
  SET_SEARCH_CONDITION,
  SET_PROCESS_NO_FROM,
  SET_PROCESS_NO_TO,
  SET_COOPERATION_DATE_FROM,
  SET_COOPERATION_DATE_TO,
  SET_STATUS,
  SET_TSR_CD,
  SET_TSR_COMPANY_CD,
  SET_TRADE_KEY,
  SET_EXTERNAL_DATA_HISTORY_LIST,
  SET_INIT_SEARCH_CONDITION,
  SET_LIMIT_MESSAGE,
  SET_DOWNLOAD_LIMIT_OVER_FLG,
  SET_DOWNLOAD_LIMIT_OVER_MSG,
  SET_NOW_PAGE,
  SET_ERR_PROCESS_NO_FROM_MSG,
  SET_ERR_PROCESS_NO_TO_MSG,
  SET_ERR_COOPERATION_DATE_FROM_MSG,
  SET_ERR_COOPERATION_DATE_TO_MSG,
  SET_ERR_TSR_CD_MSG,
  SET_ERR_TSR_COMPANY_CD_MSG,
  SET_ERR_TRADE_KEY_MSG,
  SET_ERR_PROCESS_NO_FROM_FLG,
  SET_ERR_PROCESS_NO_TO_FLG,
  SET_ERR_COOPERATION_DATE_FROM_FLG,
  SET_ERR_COOPERATION_DATE_TO_FLG,
  SET_ERR_TSR_CD_FLG,
  SET_ERR_TSR_COMPANY_CD_FLG,
  SET_ERR_TRADE_KEY_FLG,
  SET_POLLING_ID,
  SET_IMPORT_STATUS,
  SET_EX_PROCESS_NO_FROM,
  SET_EX_PROCESS_NO_TO,
  SET_CREATE_DATE_FROM,
  SET_CREATE_DATE_TO,
  SET_LINKAGE_PROCESS_NO,
  SET_ERR_EX_PROCESS_NO_FROM_MSG,
  SET_ERR_EX_PROCESS_NO_TO_MSG,
  SET_ERR_CREATE_DATE_FROM_MSG,
  SET_ERR_CREATE_DATE_TO_MSG,
  SET_ERR_LINKAGE_PROCESS_NO_MSG,
  SET_EX_SEARCH_CONDITION,
  SET_ERR_EX_PROCESS_NO_FROM_FLG,
  SET_ERR_EX_PROCESS_NO_TO_FLG,
  SET_ERR_CREATE_DATE_FROM_FLG,
  SET_ERR_CREATE_DATE_TO_FLG,
  SET_ERR_LINKAGE_PROCESS_NO_FLG,
  SET_EX_NOW_PAGE,
  SET_EXTERNAL_DATA_SEND_HISTORY_LIST,
  SET_EX_LIMIT_MESSAGE,
  SET_INIT_EX_SEARCH_CONDITION,
} from '../actions/ExternalDataHistoryAction';

// ----------------- 外部データ取込 -----------------
// 検索条件(初期値)
const initDispSearchCondition = {
  processNoFrom: null,
  processNoTo: null,
  cooperationDateFrom: moment().toDate(),
  cooperationDateTo: moment().toDate(),
  status: ['11', '12'],
  statusIem: EXTERNALDATA_STATUS,
  tsrCd: null,
  tsrCompanyCd: null,
  tradeKey: null,
  limitMessage: null,
};

// 入力チェック用エラー情報
const initErrInfo = {
  // エラーメッセージ
  errProcessNoFromMsg: '',
  errProcessNoToMsg: '',
  errCooperationDateFromMsg: '',
  errCooperationDateToMsg: '',
  errTsrCdMsg: '',
  errTsrCompanyCdMsg: '',
  errTradeKeyMsg: '',

  // エラーフラグ
  errFlg: {
    errProcessNoFromFlg: false,
    errProcessNoToFlg: false,
    errCooperationDateFromFlg: false,
    errCooperationDateToFlg: false,
    errTsrCdFlg: false,
    errTsrCompanyCdFlg: false,
    errTradeKeyFlg: false,
  },
};

// -------------------- 外部送信 --------------------
// 検索条件(初期値)
const initExDispSearchCondition = {
  exProcessNoFrom: null,
  exProcessNoTo: null,
  createDateFrom: moment().toDate(),
  createDateTo: moment().toDate(),
  linkageProcessNo: null,
  exLimitMessage: null,
};

// 入力チェック用エラー情報
const initExErrInfo = {
  // エラーメッセージ
  errExProcessNoFromMsg: '',
  errExProcessNoToMsg: '',
  errCreateDateFromMsg: '',
  errCreateDateToMsg: '',
  errLinkageProcessNo: '',

  // エラーフラグ
  exErrFlg: {
    errExProcessNoFromFlg: false,
    errExProcessNoToFlg: false,
    errCreateDateFromFlg: false,
    errCreateDateToFlg: false,
    errLinkageProcessNoFlg: false,
  },
};

const initState = {
  searchCondition: null,
  // 表示タブ
  extab: EXTERNALDATA_TAB.TAB_INPORT,
  // --------外部データ取込--------
  // 現在のページ
  nowPage: null,
  // 検索結果
  externalDataHistoryList: null,
  // 入力チェック用エラー情報
  ...initErrInfo,
  // 検索条件
  ...initDispSearchCondition,
  downloadLimitOverFlg: false,
  downloadLimitOverMsg: null,
  // ポーリングID
  pollingId: null,
  // 名刺取込実行ステータス
  importStatus: null,
  // -----------外部送信-----------
  // 現在のページ
  exNowPage: null,
  // 検索結果
  externalDataSendHistoryList: null,
  // 入力チェック用エラー情報
  ...initExErrInfo,
  // 検索条件
  ...initExDispSearchCondition,
};

const initInState = {
  // 表示タブ
  extab: EXTERNALDATA_TAB.TAB_INPORT,
  // --------外部データ取込--------
  // 現在のページ
  nowPage: null,
  // 検索結果
  externalDataHistoryList: null,
  // 入力チェック用エラー情報
  ...initErrInfo,
  // 検索条件
  ...initDispSearchCondition,
  downloadLimitOverFlg: false,
  downloadLimitOverMsg: null,
  // ポーリングID
  pollingId: null,
  // 名刺取込実行ステータス
  importStatus: null,
};

const initExState = {
  // 表示タブ
  extab: EXTERNALDATA_TAB.TAB_EXPORT,
  // -----------外部送信-----------
  // 現在のページ
  exNowPage: null,
  // 検索結果
  externalDataSendHistoryList: null,
  // 入力チェック用エラー情報
  ...initExErrInfo,
  // 検索条件
  ...initExDispSearchCondition,
};

export default (state = initState, action) => {
  switch (action.type) {
    // 初期設定
    case SET_EXTAB:
      return { ...state, extab: action.extab };
    case SET_INIT_EXTERNAL_DATA_HISTORY_STATE:
      return { ...state, ...initInState };
    case SET_INIT_EXTERNAL_DATA_SEND_HISTORY_STATE:
      return { ...state, ...initExState };
    // ---------- 外部データ取込 ----------
    // --------- 検索条件 ---------
    case SET_SEARCH_CONDITION:
      return { ...state, searchCondition: action.searchCondition };
    case SET_PROCESS_NO_FROM:
      return { ...state, processNoFrom: action.processNoFrom };
    case SET_PROCESS_NO_TO:
      return { ...state, processNoTo: action.processNoTo };
    case SET_COOPERATION_DATE_FROM:
      return { ...state, cooperationDateFrom: action.cooperationDateFrom };
    case SET_COOPERATION_DATE_TO:
      return { ...state, cooperationDateTo: action.cooperationDateTo };
    case SET_STATUS:
      return { ...state, status: action.status };
    case SET_TSR_CD:
      return { ...state, tsrCd: action.tsrCd };
    case SET_TSR_COMPANY_CD:
      return { ...state, tsrCompanyCd: action.tsrCompanyCd };
    case SET_TRADE_KEY:
      return { ...state, tradeKey: action.tradeKey };
    // ------ エラーメッセージ ------
    case SET_ERR_PROCESS_NO_FROM_MSG:
      return { ...state, errProcessNoFromMsg: action.errProcessNoFromMsg };
    case SET_ERR_PROCESS_NO_TO_MSG:
      return { ...state, errProcessNoToMsg: action.errProcessNoToMsg };
    case SET_ERR_COOPERATION_DATE_FROM_MSG:
      return { ...state, errCooperationDateFromMsg: action.errCooperationDateFromMsg };
    case SET_ERR_COOPERATION_DATE_TO_MSG:
      return { ...state, errCooperationDateToMsg: action.errCooperationDateToMsg };
    case SET_ERR_TSR_CD_MSG:
      return { ...state, errTsrCdMsg: action.errTsrCdMsg };
    case SET_ERR_TSR_COMPANY_CD_MSG:
      return { ...state, errTsrCompanyCdMsg: action.errTsrCompanyCdMsg };
    case SET_ERR_TRADE_KEY_MSG:
      return { ...state, errTradeKeyMsg: action.errTradeKeyMsg };
    // --------- エラーフラグ ---------
    case SET_ERR_PROCESS_NO_FROM_FLG:
      return {
        ...state,
        errFlg: {
          ...state.errFlg,
          errProcessNoFromFlg: action.errProcessNoFromFlg,
        },
      };
    case SET_ERR_PROCESS_NO_TO_FLG:
      return {
        ...state,
        errFlg: {
          ...state.errFlg,
          errProcessNoToFlg: action.errProcessNoToFlg,
        },
      };
    case SET_ERR_COOPERATION_DATE_FROM_FLG:
      return {
        ...state,
        errFlg: {
          ...state.errFlg,
          errCooperationDateFromFlg: action.errCooperationDateFromFlg,
        },
      };
    case SET_ERR_COOPERATION_DATE_TO_FLG:
      return {
        ...state,
        errFlg: {
          ...state.errFlg,
          errCooperationDateToFlg: action.errCooperationDateToFlg,
        },
      };
    case SET_ERR_TSR_CD_FLG:
      return {
        ...state,
        errFlg: {
          ...state.errFlg,
          errTsrCdFlg: action.errTsrCdFlg,
        },
      };
    case SET_ERR_TSR_COMPANY_CD_FLG:
      return {
        ...state,
        errFlg: {
          ...state.errFlg,
          errTsrCompanyCdFlg: action.errTsrCompanyCdFlg,
        },
      };
    case SET_ERR_TRADE_KEY_FLG:
      return {
        ...state,
        errFlg: {
          ...state.errFlg,
          errTradeKeyFlg: action.errTradeKeyFlg,
        },
      };

    case SET_NOW_PAGE:
      return { ...state, nowPage: action.nowPage };
    case SET_EXTERNAL_DATA_HISTORY_LIST:
      return { ...state, externalDataHistoryList: action.externalDataHistoryList };
    case SET_LIMIT_MESSAGE:
      return { ...state, limitMessage: action.limitMessage };
    case SET_DOWNLOAD_LIMIT_OVER_FLG:
      return { ...state, downloadLimitOverFlg: action.downloadLimitOverFlg };
    case SET_DOWNLOAD_LIMIT_OVER_MSG:
      return { ...state, downloadLimitOverMsg: action.downloadLimitOverMsg };
    case SET_INIT_SEARCH_CONDITION:
      // 検索条件クリアボタン押下時の処理
      return {
        ...state,
        ...initInState,
        // 検索条件を初期化
        ...initDispSearchCondition,
      };
    case SET_POLLING_ID:
      return { ...state, pollingId: action.pollingId };
    case SET_IMPORT_STATUS:
      return { ...state, importStatus: action.importStatus };

      // ------------ 外部送信 ------------
      // --------- 検索条件 ---------
    case SET_EX_SEARCH_CONDITION:
      return { ...state, exSearchCondition: action.exSearchCondition };
    case SET_EX_PROCESS_NO_FROM:
      return { ...state, exProcessNoFrom: action.exProcessNoFrom };
    case SET_EX_PROCESS_NO_TO:
      return { ...state, exProcessNoTo: action.exProcessNoTo };
    case SET_CREATE_DATE_FROM:
      return { ...state, createDateFrom: action.createDateFrom };
    case SET_CREATE_DATE_TO:
      return { ...state, createDateTo: action.createDateTo };
    case SET_LINKAGE_PROCESS_NO:
      return { ...state, linkageProcessNo: action.linkageProcessNo };
    // ------ エラーメッセージ ------
    case SET_ERR_EX_PROCESS_NO_FROM_MSG:
      return { ...state, errExProcessNoFromMsg: action.errExProcessNoFromMsg };
    case SET_ERR_EX_PROCESS_NO_TO_MSG:
      return { ...state, errExProcessNoToMsg: action.errExProcessNoToMsg };
    case SET_ERR_CREATE_DATE_FROM_MSG:
      return { ...state, errCreateDateFromMsg: action.errCreateDateFromMsg };
    case SET_ERR_CREATE_DATE_TO_MSG:
      return { ...state, errCreateDateToMsg: action.errCreateDateToMsg };
    case SET_ERR_LINKAGE_PROCESS_NO_MSG:
      return { ...state, errLinkageProcessNoMsg: action.errLinkageProcessNoMsg };
    // --------- エラーフラグ ---------
    case SET_ERR_EX_PROCESS_NO_FROM_FLG:
      return {
        ...state,
        exErrFlg: {
          ...state.exErrFlg,
          errExProcessNoFromFlg: action.errExProcessNoFromFlg,
        },
      };
    case SET_ERR_EX_PROCESS_NO_TO_FLG:
      return {
        ...state,
        exErrFlg: {
          ...state.exErrFlg,
          errExProcessNoToFlg: action.errExProcessNoToFlg,
        },
      };
    case SET_ERR_CREATE_DATE_FROM_FLG:
      return {
        ...state,
        exErrFlg: {
          ...state.exErrFlg,
          errCreateDateFromFlg: action.errCreateDateFromFlg,
        },
      };
    case SET_ERR_CREATE_DATE_TO_FLG:
      return {
        ...state,
        exErrFlg: {
          ...state.exErrFlg,
          errCreateDateToFlg: action.errCreateDateToFlg,
        },
      };
    case SET_ERR_LINKAGE_PROCESS_NO_FLG:
      return {
        ...state,
        exErrFlg: {
          ...state.exErrFlg,
          errLinkageProcessNoFlg: action.errLinkageProcessNoFlg,
        },
      };

    case SET_EX_NOW_PAGE:
      return { ...state, exNowPage: action.exNowPage };
    case SET_EXTERNAL_DATA_SEND_HISTORY_LIST:
      return { ...state, externalDataSendHistoryList: action.externalDataSendHistoryList };
    case SET_EX_LIMIT_MESSAGE:
      return { ...state, exLimitMessage: action.exLimitMessage };
    case SET_INIT_EX_SEARCH_CONDITION:
      // 検索条件クリアボタン押下時の処理
      return {
        ...state,
        ...initExState,
        // 検索条件を初期化
        ...initExDispSearchCondition,
      };
    default:
      return state;
  }
};
